// src/components/MobileBottomActionBar.jsx
import React from 'react';
import { Paper, Button, Box, CircularProgress, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const MobileBottomActionBar = ({
  selectedRows,
  selectedTranches,
  cashflowData,
  analyticsMainData,
  parsedData,
  generationLoading,
  loading,
  hasUnsavedChanges,
  generatedWithYieldOrSpread,
  saveSkipsGenerate = false,
  onGenerate,
  onAddSecurity,
  onEditSecurity,
  onClear,
  onSave
}) => {
  const theme = useTheme();
  const calculateDisabled = selectedRows.length === 0;
  const isDealLoaded = selectedRows.length > 0;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        bgcolor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        p: 1.25,
        display: 'flex',
        gap: 1,
        flexWrap: 'wrap',
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)'
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={onGenerate}
        disabled={calculateDisabled || selectedTranches.length === 0 || generationLoading}
        fullWidth
        sx={{
          fontWeight: 600,
          py: 1,
          textTransform: 'none',
          fontSize: '13px',
          minHeight: 40,
          borderRadius: 1.5,
          flex: 1
        }}
      >
        {generationLoading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CircularProgress size={14} sx={{ color: 'white' }} />
            <span style={{ fontSize: '12px' }}>Gen...</span>
          </Box>
        ) : selectedRows.length === 0 ? (
          'Select Deal'
        ) : selectedTranches.length === 0 ? (
          'Select Tranches'
        ) : ((!cashflowData.length || !analyticsMainData.length || !parsedData.length) ?
          'Generate' : 'Re-Gen')}
      </Button>

      <Button
        variant="outlined"
        color="primary"
        onClick={isDealLoaded ? onEditSecurity : onAddSecurity}
        startIcon={isDealLoaded ? <EditIcon sx={{ fontSize: 16 }} /> : <AddIcon sx={{ fontSize: 16 }} />}
        sx={{
          fontWeight: 600,
          py: 1,
          px: 1.5,
          textTransform: 'none',
          fontSize: '13px',
          minHeight: 40,
          borderRadius: 1.5,
          minWidth: 70,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2
          }
        }}
      >
        {isDealLoaded ? 'Edit' : 'Add'}
      </Button>

      <Button
        variant="outlined"
        color="error"
        onClick={onClear}
        disabled={selectedRows.length === 0}
        sx={{
          fontWeight: 600,
          py: 1,
          px: 1.5,
          textTransform: 'none',
          fontSize: '13px',
          minHeight: 40,
          borderRadius: 1.5,
          minWidth: 70,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2
          }
        }}
      >
        Clear
      </Button>

      <Button
        variant="contained"
        onClick={onSave}
        disabled={loading || !selectedTranches.length || (!saveSkipsGenerate && (!cashflowData.length || !analyticsMainData.length || !parsedData.length)) || generatedWithYieldOrSpread}
        sx={{
          bgcolor: loading ? '#9ca3af' : '#16a34a',
          color: 'white',
          fontWeight: 600,
          py: 1,
          px: 1.5,
          textTransform: 'none',
          fontSize: '13px',
          minHeight: 40,
          borderRadius: 1.5,
          minWidth: 70,
          '&:hover': {
            bgcolor: '#15803d'
          },
          '&:disabled': {
            bgcolor: '#d1d5db',
            color: '#9ca3af'
          }
        }}
      >
        {loading ? '...' : hasUnsavedChanges ? '⚠ Save' : 'Save'}
      </Button>
    </Paper>
  );
};

export default MobileBottomActionBar;

